window.defaultBps = {
  desktop: 1023,
  tablet: 836,
  mobile: 414,
  above: {
    sm: window.matchMedia("(min-width: 414px)"),
    md: window.matchMedia("(min-width: 836px)"),
    lg: window.matchMedia("(min-width: 1024px)"),
  },
  below: {
    sm: window.matchMedia("(max-width: 413px)"),
    md: window.matchMedia("(max-width: 835px)"),
    lg: window.matchMedia("(max-width: 1023px)"),
  },
};

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
